import { render, staticRenderFns } from "./OnlineConsulting.vue?vue&type=template&id=bb57af48&scoped=true&"
import script from "./OnlineConsulting.vue?vue&type=script&lang=js&"
export * from "./OnlineConsulting.vue?vue&type=script&lang=js&"
import style0 from "./OnlineConsulting.vue?vue&type=style&index=0&id=bb57af48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb57af48",
  null
  
)

export default component.exports